// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n        mat-menu {\n            color: black;\n          }\n        .fa-icon {\n          width: 20px;\n          height: 20px;\n          font-size: 20px;\n        }\n\n    ", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
